import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { OrderRequestStatus } from "../../../../../common/types/OrderRequestStatus";

export const renderOrderRequestStatus = <T,>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return renderEnumValue(OrderRequestStatus, item, _index, column);
};
